
// TopicsSection
import React from "react";

const topics = [
  {
    icon: "💰",
    title: "Investing Fundamentals",
    description: "Start building a long-term portfolio with AI lessons."
  },
  {
    icon: "💳",
    title: "Trading Basics",
    description: "Learn to place smarter trades, guided by AI."
  },
  {
    icon: "📊",
    title: "Exploring the Markets",
    description: "Understand how stocks, forex, and crypto move — with AI clarity."
  },
  {
    icon: "🏠",
    title: "Alternative Assets",
    description: "Break down bonds, real estate, and commodities with help from AI."
  },
  {
    icon: "🌱",
    title: "Investment Strategies",
    description: "Explore passive and active strategies, AI-powered."
  },
  {
    icon: "🎓",
    title: "Financial Concepts",
    description: "Make sense of economic trends and news with AI simplification."
  },
];

const TopicsSection = () => {
  return (
    <section className="why-choose">
      <h3>Understand Every Topic With AI</h3>
      <div className="benefits-grid">
        {topics.map((item, index) => (
          <div className="benefit-item" key={index}>
            <strong>{item.icon} </strong>
            <strong> {item.title}</strong>
            <p>{item.description}</p>
            <a href="/aha-moment">Explore {item.title} →</a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TopicsSection;